<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other"></i>
        用户编辑
      </div>
    </div>
    <el-form ref="form" :model="form" label-width="110px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="账号性质"
            prop="natureId"
            :rules="{
              message: '请填写/选择',
              trigger: 'blur',
              required: true,
            }"
          >
            <el-select v-model="type" filterable placeholder="请选择" @change="typeChange">
              <el-option v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态" prop="status">
            <el-select v-model="form.status" filterable placeholder="请选择">
              <el-option label="正常" value="1"></el-option>
              <el-option label="停用" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" v-if="type == 2">
          <el-form-item
            :rules="{
              message: '请填写/选择',
              trigger: 'blur',
              required: true,
            }"
            label="所属单位"
            prop="affiliatedUnit"
          >
            <el-select v-model="form.affiliatedUnit" filterable placeholder="请选择">
              <el-option v-for="item in compOption" :key="item.key" :label="item.label" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="登录账号"
            prop="userName"
            :rules="{
              message: '请填写/选择',
              trigger: 'blur',
              required: true,
            }"
          >
            <el-input v-model="form.userName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <!--                <el-col :span="6">-->
        <!--                    <el-form-item label="登录密码" prop="login_pass">-->
        <!--                        <el-input v-model="form.login_pass" placeholder="请输入" ></el-input>-->
        <!--                    </el-form-item>-->
        <!--                </el-col>-->
        <el-col :span="6">
          <el-form-item
            label="真实姓名"
            prop="nickName"
            :rules="{
              message: '请填写/选择',
              trigger: 'blur',
              required: true,
            }"
          >
            <el-input v-model="form.nickName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="分配角色" prop="roleIds" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
            <el-select v-model="form.roleIds" multiple placeholder="请选择" filterable>
              <el-option v-for="item in roleOptions" :label="item.roleName" :value="item.roleId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="手机号" prop="phonenumber" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
            <el-input v-model="form.phonenumber" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="电子邮箱" prop="email" >
            <el-input v-model="form.email" placeholder="请输入" readonly onfocus="this.removeAttribute('readonly');"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="修改密码" prop="login_pass" >
            <el-input type="password" v-model="form.password" placeholder="请输入" readonly onfocus="this.removeAttribute('readonly');"></el-input>
          </el-form-item>
        </el-col>
        <!-- {{ form.region}} -->
        <el-col :span="6">
          <el-form-item label="所在地区" :rules="rules">
            <el-select v-model="form.region" placeholder="请选择地区" @change="adressChange">
              <el-option v-for="item in adress" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-if="type == 1">
        <div class="common-page common-head">
          <div class="common-page common-head-title">
            <i class="icon-tr-other"></i>
            监管账号
          </div>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="地区" prop="province" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
              <!-- <el-checkbox v-model="menuExpand" @change="handleCheckedTreeExpand($event, 'menu')">展开/折叠</el-checkbox>
                      <el-checkbox v-model="menuNodeAll" @change="handleCheckedTreeNodeAll($event, 'menu')">全选/全不选</el-checkbox>
                      <el-checkbox v-model="menuCheckStrictly" @change="handleCheckedTreeConnect($event, 'menu')">父子联动</el-checkbox>
                -->
              <div style="height: 300px; overflow: auto" class="mt10">
                <el-tree :data="area" ref="areas" show-checkbox accordion node-key="id"> </el-tree>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="所属行业"
              prop="industryCode"
              :rules="{
                message: '请填写/选择',
                trigger: 'blur',
                required: true,
              }"
            >
              <el-select v-model="industryValue" @change="changeSelect" placeholder="请选择" filterable multiple>
                <el-option label="全选" value="全选" @click.native="selectAllHang"></el-option>
                <el-option v-for="item in industryCodeList" :label="item.name" :value="item.code"></el-option>
              </el-select>
              <!-- <v-select
                :value.sync="form.industryCode"
                :id="66"
                :multiple="true"
                :filterable="true"
              ></v-select> -->
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <div v-if="type == 3 || type == 4">
        <div class="common-page common-head">
          <div class="common-page common-head-title">
            <i class="icon-tr-other"></i>
            选择单位
          </div>
        </div>
        <el-row :gutter="20" class="center">
          <el-transfer
            style=""
            filterable
            :filter-method="filterMethod"
            :titles="['待选择单位', '已选择单位']"
            filter-placeholder="请输入单位名"
            v-model="value"
            :data="compOption"
          >
          </el-transfer>
        </el-row>
      </div>

      <div class="btn-box">
        <div class="l-btn" @click="onSubmit">保存</div>
        <div class="l-btn ml20" @click="$router.back()">返回</div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { getUser, addUser, updateUser } from "@/api/system/user";
import { getAreaNew } from "@/api/common";

import t from "../../../utils/ezuikit";
export default {
  // props:[''],
  data() {
    return {
      areaValue: ["370000", "370200", "370202"],
      menuExpand: false,
      menuNodeAll: false,
      menuCheckStrictly: false,
      filterMethod(query, item) {
        return item.label.indexOf(query) > -1;
      },
      area: [],
      industryValue: [], // 所属行业 选择
      compOption: [],
      areaParams: {
        c_company_num: "",
        wenwu: 0,
      },
      typeList: [
        { name: "监管账号", value: "1" },
        { name: "接警账号", value: "4" },
        { name: "集团/园区账号", value: "3" },
        { name: "单位账号", value: "2" },
      ],
      type: "",
      unitsSerchList: [],
      // data: [
      //   {
      //     label: "ces",
      //     key: 222,
      //   },
      // ],
      value: [], // 已选择的单位
      form: {
        userId: "", //  "用户userId",
        userName: "", // "账号",
        password: "", //密码",
        nickName: "", // "真实姓名",
        email: "", // "邮箱",
        phonenumber: "", //手机号",
        status: "1", //1启用 0停用",
        roleIds: [], //角色id，可以多个",
        natureId: "", // 1",
        industryCode: "", //行业编号：80,81,82",
        province: "", // "省",
        city: "", //市",
        area: "", // "区",
        affiliatedUnit: "", // 单个单位
        regulatoryUnit: "", //多个账号
        region: null, // 城市选择
      },
      adress: [
        { value: 1, label: "青岛" },
        { value: 2, label: "济南" },
      ],
      roleOptions: [],
      id: this.$route.query.userId,
      rule: {
        company_num: {
          required: true,
          message: "请选择所属单位",
          trigger: "change",
        },
        role_key: {
          required: true,
          message: "请选择分配角色",
          trigger: "change",
        },
      },

      industryCodeList: [],

      rules: [{ required: true, message: "请选择所在地址", trigger: "change " }],
    };
  },
  async created() {
    await this.$get("/trmonitor/industry/list").then((res) => {
      this.industryCodeList = res.rows;
    });
    // 获取公司
    this.$get("/trmonitor/company/allList ").then((res) => {
      var compOption = [];
      res.data.map((item) => {
        var obj = {};
        obj.label = item.cName;
        obj.key = item.cCompanyNum;
        compOption.push(obj);
      });
      this.compOption = compOption;
    });
    await getAreaNew().then((res) => {
      var arr = [];
      res.data.map((it) => {
        var obj = {};
        obj.label = it.areaName;
        obj.id = it.areaCode;
        obj.leval = it.treeLevel;
        // obj.push(it)
        if (it.child && it.child.length) {
          // var obj = {}
          obj.children = [];

          it.child.map((itch) => {
            var obj2 = {};
            obj2.label = itch.areaName;
            obj2.id = itch.areaCode;
            obj2.leval = itch.treeLevel;

            if (itch.child && itch.child.length) {
              obj2.children = [];
              itch.child.map((itthree) => {
                var obj3 = {};
                obj3.label = itthree.areaName;
                obj3.id = itthree.areaCode;
                obj3.leval = itthree.treeLevel;
                obj2.children.push(obj3);
              });
            }
            obj.children.push(obj2);
          });
        }
        arr.push(obj);
      });
      this.area = arr;
    });
    if (this.$route.query.userId) {
      await getUser(this.id).then((res) => {
        log(res)
        this.roleOptions = res.data.roles;
        this.form = res.data.data;
        this.form.roleIds = res.data.roleIds || [];
        this.form.password = "";
        this.industryValue = res.data.data.industryCode ? res.data.data.industryCode.split(",") : [];
        if (this.industryValue.length === this.industryCodeList.length) {
          this.industryValue.unshift("全选");
        }
        var { area, regulatoryUnit } = res.data.data;
        console.log(regulatoryUnit,'area');
        this.type = res.data.data.natureId;
        setTimeout(() => {
          var arr = area ? area.split(",") : [];

          if (arr.length && this.$refs.areas) this.$refs.areas.setCheckedKeys(arr);
          var comValue = regulatoryUnit ? regulatoryUnit.split(",") : [];
   
          this.value = comValue;
        }, 1);
      });
    } else {
      await getUser().then((response) => {
        this.postOptions = response.data.posts;
        this.roleOptions = response.data.roles;
      });
    }
    // 获取区域

    // this.$post("/devicemanage/selectconpanybyme", {
    //   c_belong_profession: 174,
    // }).then((res) => {
    //   this.units = res.data;
    // });
    // if (this.$route.query.id) {
    //   this.$post(`/crt/areadetail/${this.$route.query.id}`).then((res) => {
    //     this.form = res.data;
    //     if (res.data.image_name) {
    //       this.fileList.push({ name: "图片" + 1, url: res.data.image_name });
    //     }
    //   });
    // }
  },
  watch: {},
  methods: {
    // 树权限（展开/折叠）
    selectAllHang() {
      if (this.industryValue.length < this.industryCodeList.length) {
        this.industryValue = [];
        this.industryCodeList.map((item) => {
          this.industryValue.push(item.code);
        });
        this.industryValue.unshift("全选");
      } else {
        this.industryValue = [];
      }
    },
    changeSelect(val) {
      if (!val.includes("全选") && val.length === this.industryCodeList.length) {
        this.industryValue.unshift("全选");
      } else if (val.includes("全选") && val.length - 1 < this.industryCodeList.length) {
        this.industryValue = this.industryValue.filter((item) => {
          return item !== "全选";
        });
      }
    },
    handleCheckedTreeExpand(value, type) {
      console.log(this.$refs.areas.store);

      let treeList = this.area;
      for (let i = 0; i < treeList.length; i++) {
        console.log(this.$refs.areas.store.nodesMap[treeList[i].id]);
        return;
        this.$refs.areas.store.nodesMap[treeList[i].id].expanded = value;
      }
    },

    unitChange(val) {
      this.areaParams.c_company_num = val;
      this.parkSelected = [];
      this.fatherSelected = [];
      // this.areaParams.sheng = val[0] || '';
      // this.areaParams.shi = val[1] || '';
      // this.areaParams.qv = val[2] || '';
      // this.areaParams.wenwu = this.form.u_wenwu
      this.getUnit();
    },
    typeChange(v) {
      this.industryValue = [];
      this.comValue = [];
    },
    // wenradio(val){
    //     this.parkSelected = []
    //     this.fatherSelected = []
    //     this.unitChange(this.areaValue)
    //   },
    getUnit() {
      this.$post("/trxf/main/xf/danwei/xfdanweixinxi/baseselectarea", this.areaParams).then((res) => {
        this.areaunits = res.data[0];
        this.yuanqvunits = res.data[1] ? res.data[1] : [];
      });
    },

    selectAll(type, isTrue) {
      var arr = [];
      var selectArr = this.unitsSerchList.length ? this.unitsSerchList : this.areaunits;
      selectArr.map((item) => {
        arr.push(item.c_company_num);
      });
      if (type == "father") {
        isTrue ? (this.fatherSelected = []) : (this.fatherSelected = arr);
        this.handlePark(this.fatherSelected);
      } else if (type == "park") {
        isTrue ? (this.parkSelected = []) : (this.parkSelected = arr);
        this.handlePark(this.parkSelected, "u_yuanqv");
      }
    },

    onSubmit() {
      this.form.natureId = this.type;
      // 选择省市区
      var arr = this.$refs.areas ? this.$refs.areas.getCheckedNodes(false, true) : [];
      if (arr.length) {
        var province = "";
        var city = "";
        var area = "";
        arr.map((item) => {
          if (item.leval == 0) {
            province += "," + item.id;
          } else if (item.leval == 1) {
            city += "," + item.id;
          } else if (item.leval == 2) {
            area += "," + item.id;
          }
        });
      }
      this.form.province = province ? province.substring(1, province.length) : "";
      this.form.city = city ? city.substring(1, city.length) : "";
      this.form.area = area ? area.substring(1, area.length) : "";

      // 选择所属行业单位
      var arr = this.industryValue;
      arr.map((it, index) => {
        if (it === "全选") {
          arr.splice(index, 1);
        }
      });
      this.form.industryCode = arr.join(",");
      if (this.value && this.value.length) {
        this.form.regulatoryUnit = this.value.join(",");
      }else{
        this.form.regulatoryUnit=''
      }
      console.log( this.form.regulatoryUnit,11111111);


      this.$refs.form.validate((valid) => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    adressChange(val) {
      if (this.adress.region == 1) this.form.region = "青岛";
      else if (this.adress.region == 2) this.form.region = "济南";
    },
    save() {
      if (this.form.userId) {
        // 修改
        updateUser(this.form).then((res) => {
          if (res.code == 200) {
            this.$message({message: res.msg,type: "success", duration: 700,});
            console.log(this.form.userId == this.$store.state.userId, this.form.userId, this.$store.state.userInfo.userId);
            if (this.form.userId == this.$store.state.userInfo.userId) {
              // console.log(1111)
              this.$store.dispatch("GetInfo");
            }
            setTimeout(() => {
              this.$router.back();
            }, 400);
          }
        });
      } else {
        // 新增
        addUser(this.form)
          .then((res) => {
            if (res.code == 200) {
              this.$message({message: res.msg,type: "success", duration: 700,});
              setTimeout(() => {
                this.$router.back();
              }, 400);
            }
          })
          .catch((err) => {});
      }
    },
    areaChange(val) {
      log(val);
      this.form.base.c_province = val[0];
      this.form.base.c_city = val[1];
      this.form.base.c_area = val[2];
    },
  },
};
</script>

<style scoped></style>
